import { render, staticRenderFns } from "./ConfigCustomsTeamTab.vue?vue&type=template&id=4b4266bd&scoped=true"
import script from "./ConfigCustomsTeamTab.vue?vue&type=script&lang=js"
export * from "./ConfigCustomsTeamTab.vue?vue&type=script&lang=js"
import style0 from "./ConfigCustomsTeamTab.vue?vue&type=style&index=0&id=4b4266bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4266bd",
  null
  
)

export default component.exports